export const USERNAMES = ['APOD', 'EPIC', 'NASA', 'MaRoPho', 'Earth'];
